/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-06 10:19:30
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-12 13:57:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/Price/index.tsx
 */
import React from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { TableSelect } from '@/src/components';
import {
  SectionCollapse,
  // Select,
  // Input,
  SizeFittingTable,
} from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import { EnumTablePosition } from '@/src/types/common/common';
import { ProductItem } from '@/src/types/common/product';

import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { translatePriceTier } from '../../SalesChannelProductsLinkProduct/util';
import styles from './style.module.less';
import { EnumProductType } from 'src/types/common/product';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { get } from 'lodash';

type Props = {
  products: Array<ProductItem>;
  currency: string;
  currencyInfo: any;
  isVirtual: boolean;
  disabled?: boolean;
  onChangeProductRrp?: (index: number, value: string) => void;
  onChangeListPrice?: (index: number, uuid: string, value: string) => void;
  getI18n: (k: string) => string;
  salesChannelCurrency: string;
};

function Price({
  products,
  currencyInfo,
  onChangeProductRrp,
  onChangeListPrice,
  currency,
  //  isVirtual,
  disabled,
  getI18n,
  salesChannelCurrency,
}: Props) {
  //console.log('products', products);
  const history = useHistory();

  const sc = useSalesChannel();
  const decimalPosition = get(sc, 'decimalPosition');

  const handleChangeListPrice = (index: number, value: string, option: any) => {
    if (onChangeListPrice) onChangeListPrice(index, value, option.label);
  };

  const navigateToProduct = (uuid: string, record: any) => {
    if (record.productType === 'Simple') {
      history.push(`/product/simpleProduct/${uuid}`);
    } else if (record.productType === 'Set') {
      history.push(`/product/productSet/${uuid}`);
    } else {
      history.push(`/product/virtualProduct/${uuid}`);
    }
  };

  const columns = [
    {
      width: 56,
      default: true,
      title: '',
      key: 'index',
      childGenerate: (_, __, index: number) => index + 1,
    },
    {
      title: getI18n('general.storeCommunicationSetting.product'),
      //align: 'center',
      default: true,
      minWidth: 400,
      key: 'product',
      childGenerate: (_, record, index: number) => {
        return (
          <div className={styles.products}>
            {record.thumbnailUrl && (
              <div
                className={styles.img}
                style={{
                  backgroundImage: `url('${record.thumbnailUrl}')`,
                  marginRight: 8,
                }}
              />
            )}
            <NoWrapContainer>
              <GlobalTooltip title={record.name || '-'}>
                {record.name || '-'}
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
    },
    {
      title: (
        <>
          <span>
            {!disabled && <Icon type={'iconedit'} className={styles.icon} />}
            {getI18n('general.listPrice')} ({currency})
          </span>
        </>
      ),
      align: 'right',
      minWidth: 180,
      default: true,
      childGenerate: (_, record, index: number) => {
        const {
          listPriceUuid,
          defaultSalePrice,
          listPrices,
          localPrices,
          uuid,
          productType,
          defaultCurrency,
        } = record;
        const isGiftCard = EnumProductType.GiftCard === productType;
        const options = translatePriceTier(
          listPrices,
          localPrices,
          defaultSalePrice,
          currencyInfo,
          currency,
          {
            getI18n,
            isGiftCard,
            salesChannelCurrency,
            defaultCurrency,
            decimalPosition,
          },
        );
        //console.log()
        //
        const selectLabel = options.find(
          (o) => o.value === listPriceUuid,
        )?.label;
        const id = `${uuid}ListPrice`;
        return (
          <div style={{ width: '100%' }} id={id}>
            <TableSelect
              value={listPriceUuid}
              label={<div className={styles.selectLabel}>{selectLabel}</div>}
              onChange={handleChangeListPrice.bind(this, index)}
              options={options}
              getPopupContainer={
                (triggerNode) => document.body //triggerNode.parentElement
              }
              disabled={disabled}
              //getPopupContainer={() => document.getElementById(id)}
            />
          </div>
        );
      },
    },
    {
      title: (
        <span>
          {getI18n('salesChannelProductDetail.index.rRP')} ({currency})
        </span>
      ),
      dataIndex: 'rrp',
      align: 'right',
      minWidth: 150,
      default: true,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index: number) => {
        // console.log('record', record);
        const { productType } = record;
        if (productType === 'GiftCard') {
          return '-';
        }
        return text;
      },
    },
    {
      title: '',
      default: true,
      dataIndex: 'uuid',
      align: 'center',
      width: 132,
      childGenerate: (text, record) => {
        return (
          <div
            className={styles.ahref}
            onClick={navigateToProduct.bind(this, text, record)}>
            {getI18n('salesChannelProductDetail.index.goToProduct')}
          </div>
        );
      },
    },
  ];

  const renderContent = () => {
    return (
      <div className={styles.content}>
        {/* {products.length > 1 && ( */}
        <div className={styles.table}>
          <div className={styles.tableTitle}>
            {getI18n('salesChannelProductDetail.index.selectaListPrice')}
          </div>
          <SizeFittingTable
            id='priceList'
            rowKey={'uuid'}
            className={styles.table}
            dataSource={products}
            pagination={false}
            columns={columns}
            scroll={{}}
            //scroll={{ x: 'max-content', y: 600 }}
            //    tableLayout={'fixed'}
          />
        </div>
        {/* )} */}
        {renderBottom()}
      </div>
    );
  };

  const renderBottom = () => {
    return (
      <div className={styles.bottom}>
        <Icon type='iconinfo' className={styles.icon} />
        <span>
          {`${getI18n('general.gotoStore')} > `}
          <Link to={'/productsList'}>
            {getI18n('general.storeCommunicationSetting.product')}
          </Link>
          {getI18n('salesChannelProductDetail.index.manageproductdetail')}
        </span>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <SectionCollapse
        open={true}
        id={'price'}
        titleStyle={{ height: '64px' }}
        title={
          <div className={'collapseTitle'}>
            {getI18n('salesChannelProductDetail.index.price')}
          </div>
        }
        content={renderContent()}
        openMargin={16}
      />
    </div>
  );
}

export default Price;
